module.exports = __webpack_public_path__ + "img/iconUpload.9005ab4f.svg";